import * as actionType from './types';
import axios from '../../../common/config/axios';

export const getList = (data) => dispatch => 
{
    // console.log(data);
    axios.get('commission/setting', {params: data})
    .then(function (response) 
    {
        dispatch (
        {
            type: actionType.LIST,
            value: response.data
        })
    })
    .catch(err => 
    {
    
    });
}